window.Sentry = require('@sentry/browser')

const dsn = document.querySelector('meta[name="dsn"]').content;

if (dsn) {

    const environment = document.querySelector('meta[name="environment"]').content;
    const release = document.querySelector('meta[name="release"]').content;
    const user = document.querySelector('meta[name="user"]').content;

    Sentry.init({
        dsn: dsn,
        release: release,
        initialScope: {
            tags: {
                environment: environment,
                user: user,
            },
        },
        integrations: [
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
                networkDetailAllowUrls: [window.location.origin],
            }),
        ],
        // Session Replay
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });

    if (user !== 'guest') {
        Sentry.setUser({
            email: user,
        })
    }
}
